import React from 'react';

import { Flex } from 'components/base/layout-components';
import { Inline } from 'components/base/Text';

const AfterSubmit = () => {
  return (
    <Flex direction='column' justify='center'>
      <Inline
        lineHeight='45.5px'
        size='x-x-x-x-large'
        align='center'
        weight={400}
      >
        You’ve successfully unsubscribed
      </Inline>
    </Flex>
  );
};

export default AfterSubmit;
